import * as React from 'react'
import mapboxgl from 'mapbox-gl';
import {ZoomControl, Popup, Layer, Feature } from 'react-mapbox-gl'
import {Map, Marker} from "@parsimap/react-mapbox-gl"
mapboxgl.setRTLTextPlugin('https://cdn.parsimap.ir/third-party/mapbox-gl-js/plugins/mapbox-gl-rtl-text/v0.2.3/mapbox-gl-rtl-text.js', null)

function ParsiMap(props) {
    // const [zoom, setZoom] = React.useState(null);
    const [isMoving, setIsMoving] = React.useState(false);


    const handleMove = (map) => {
        setIsMoving(false)
        const center = map.target.getCenter();
        props.handleZoom(map?.target?.transform?._zoom)
        props.setLngLat(center)
        props.handlerSearchWithLocation(center.lng || props?.lngToMap, center.lat || props?.latToMap)

    };


    return (
        <div className="view-map">
            <Map ref={props?.mapRef}
                 lat={props?.latToMap || props?.coordinates[0]?.pointX}
                 lng={props?.lngToMap || props?.coordinates[0]?.pointY}
                 zoom={props?.zoom}
                 id="parsiMap"
                 token={"p1a17b4952e44846b5a486861f1f7c9153c49fdb24"}
                 style={{"height": "300px", width: '100%'}}
                 animationMode={'flyTo'}
                 animationDuration={3000}
                 onMove={() => setIsMoving(true)}
                 onMoveEnd={!props.agent && handleMove}
            >
                {
                    props.agent ?
                        props?.coordinates?.map((item, index) =>
                            <Marker
                                style={{"position": "relative"}}
                                lngLat={[item?.pointY || props?.lngToMap || 51.4, item?.pointX || props?.latToMap || 35.7]}
                                color={
                                    ((item?.pointY == props?.lngToMap) && (item?.pointX == props?.latToMap)) ? "#FF3636" : item?.agentId ? "#f28f00" : "#007edf"
                                }
                            >
                                {/*<Popup*/}
                                {/*    coordinates={[item?.pointY || props?.lngToMap || 51.4, item?.pointX || props?.latToMap || 35.7]}*/}
                                {/*    >*/}
                                {/*   محتوای پاپ‌آپ*/}
                                {/*</Popup>*/}

                            </Marker>
                        )
                        :
                        <div className="map-marker">
                            <img src={isMoving ? "/marker-2.png" : "/marker-1.png"} alt="marker" loading="lazy"/>
                        </div>
                }

                <ZoomControl/>

            </Map>


            <div className="search-box">
                <input type="text" placeholder="جستجو..." onChange={(e) => props?.handleSearchAddress(e.target.value)}/>
            </div>
        </div>
    )
}


export default ParsiMap
